import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'designSystem/lib/utils'

const skeletonVariants = cva('rounded-md bg-muted', {
  variants: {
    variant: {
      pulse: 'animate-pulse',
      /* Use for large surfaces where whole-block `pulse` exposes color
         quantization as visible stepping. The static base plus compositor-only
         opacity overlay is noise-dithered so the fade remains smooth. */
      ditheredPulse: 'relative overflow-hidden',
    },
  },
  defaultVariants: {
    variant: 'pulse',
  },
})

function Skeleton({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof skeletonVariants>) {
  return (
    <div
      data-slot='skeleton'
      className={cn(skeletonVariants({ variant }), className)}
      {...props}>
      {variant === 'ditheredPulse' ? (
        <div
          aria-hidden='true'
          className='animate-skeleton-pulse mask-noise absolute inset-0 bg-muted-foreground/8 motion-reduce:hidden'
        />
      ) : null}
    </div>
  )
}

export { Skeleton, skeletonVariants }
